import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Köszönjük értékelését!',
  text: 'Van valami, amin javíthatunk? Ossza meg velünk véleményét.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Az Ön véleménye...'
      }
    ],
    submit: {
      label: 'Küldje el a'
    }
  }
};
